// extracted by mini-css-extract-plugin
export default {"overlayloginbgimg":"Loginpage_overlayloginbgimg__uLUQa","loginButton":"Loginpage_loginButton__ya4Jr"};